export enum SessionTimeoutActions {
  SIGN_OUT = 'signout',
  RESET = 'reset'
}
